// This file is auto-generated by generate-version.js
export const VERSION_INFO = {
  "version": "504",
  "buildTime": "2026-10-29T06:59:22.509Z"
};
